export enum Method {
  INIT = 'init',
  LOAD_TILES = 'loadTiles',
  SET_TILE_FEATURE_EXTRACT_OPTIONS = 'setTileFeatureExtractOptions',
  LOAD_GEOJSON = 'loadGeoJSON',
  GET_FORMULA = 'getFormula',
  GET_HISTOGRAM = 'getHistogram',
  GET_CATEGORIES = 'getCategories',
  GET_SCATTER = 'getScatter',
  GET_TABLE = 'getTable',
  GET_TIME_SERIES = 'getTimeSeries',
  GET_RANGE = 'getRange',
  GET_AGGREGATIONS = 'getAggregations',
}
